let resumeData = {
  "imagebaseurl":"https://jcanose81.github.io",
  "name": "Justin Canose",
  "role": "Network Engineer and Systems Administrator with Full Stack experience",
  "linkedinId":"justincanose",
  "roleDescription": "I enjoy all aspects of technology and learning about and keeping up with the latest technology.",
  "socialLinks":[
      {
        "name":"linkedin",
        "url":"https://www.linkedin.com/in/justincanose/",
        "className":"fa fa-linkedin"
      },
      {
        "name":"github",
        "url":"https://github.com/jcanose81",
        "className":"fa fa-github"
      },
    ],
  "aboutme":"Experienced IT professional with extensive background in hardware and software. Family man, dad, graphic designer, artist, blockchain enthusiast and drone hobbyist.",
  "address":"Richmond, VA",
  "email":"justin.canose@verizon.net",
  "website":"canossagraphics.com",
  
  "education":[
    {
      "UniversityName":"ECPI College of Technology",
      "specialization":"A.A.S. Computer Science",
      "MonthOfPassing":"June",
      "YearOfPassing":"2003",
      "Achievements":""
    },
    {
      "UniversityName":"Art Institute of Pittsburgh",
      "specialization":"B.S. Graphic Design",
      "MonthOfPassing":"June",
      "YearOfPassing":"2009",
      "Achievements":""
    }
  ],
  "work":[
    {
      "CompanyName":"Cushman & Wakefield | Thalhimer",
      "specialization":"Senior Network & Systems Engineer ",
      "MonthOfStarting":"May",
      "YearOfStarting":"2010",
      "YearOfLeaving":"May 2010 - ",
      "Achievements":"Manage, implement and administer network hardware, applications and projects. This includes Sophos Firewalls, Cisco routers, HP switches and unmanaged MPLS devices for network functionality of company's corporate office LAN and remote office WANs. Software implementation and administration includes our SaaS solutions for accounting and property management and multiple other SaaS and on-prem solutions. Responsible for updating code on Intranet with HTML, CSS and PHP."
    },
    {
      "CompanyName":"Canossa Graphics",
      "specialization":"Owner ",
      "MonthOfStarting":"",
      "YearOfStarting":"2009",
      "YearOfLeaving":"2009 - ",
      "Achievements":"Web and graphics"
    },
    {
      "CompanyName":"Healthcare Cable Systems",
      "specialization":"Network Support Manager",
      "MonthOfLeaving":"July 2008 - May 2010",
      "YearOfLeaving":"",
      "Achievements":"Responsible for establishing strategic plans and objectives for hospital networks. Ensured that all IT systems were functional and operated as planned."
    },
    {
      "CompanyName":"Defense Supply Center Richmond",
      "specialization":"Database Administrator",
      "MonthOfLeaving":"January 2004 - July 2008",
      "YearOfLeaving":"",
      "Achievements":""
    }
  ],
  "skillsDescription":"",
  "skills":[
    {
      "skillname":"Network Management"
    },
    {
      "skillname":"Firewall Ports & rules"
    },
    {
      "skillname":"Full Stack"
    },
    {
      "skillname":"SaaS"
    },
    {
      "skillname":"IIS"
    },
    {
      "skillname":"VMware"
    },
    {
      "skillname":"Scripting"
    },
    {
      "skillname":"Telecom (Avaya)"
    }
  ],
  "portfolio":[
    {
      "name":"soapchips",
      "description":"website",
      "imgurl":"images/portfolio/soapchips.jpg"
    },
    {
      "name":"raysofcolorado",
      "description":"logodesign",
      "imgurl":"images/portfolio/rays.jpg"
    },
    {
      "name":"Intranet",
      "description":"Thalhimer Intranet",
      "imgurl":"images/portfolio/intranet.jpg"
    },
    {
      "name":"canossagraphics",
      "description":"website",
      "imgurl":"images/portfolio/canossa.jpg"
    }
  ],
  "testimonials":[
    {
      "description":"Right from the start, Justin impressed me with his ability to take my ideas and turn it into a logo that perfectly fits my company. He paid attention to the small details that make all the difference. Justin is an asset to any company that needs graphic design.",
      "name":"Chris Sniffen - Ray's of Colorado"
    },
    {
      "description":"Need to find more people to say how awesome I am.",
      "name":"Justin"
    },
    {
      "description":"Need to find another person.",
      "name":"Justin"
    }
  ]
}

export default resumeData
